import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

function Tools() {
  const { t } = useTranslation();

  return (
    <div className="article-container">
      <h1>{t('tools.title')}</h1>
      <p>{t('tools.comingSoon')}</p>
    </div>
  );
}

export default Tools;
